import { FragenblockJson } from "@/models/ba/interfaces/IFragenblock";
import { AxiosRequestConfig } from "axios";
import apiClient, { strapiApiUrl } from "./api";

interface PostInput { newFragenblock: FragenblockJson, parentFragenblockId: number; }
interface PutInput { fragenblockFields: Record<string, any>; }
interface DeleteInput { id: number; parentId: number; }
interface ReplaceInput { id: number, newFragenblockData: FragenblockJson[],  }
interface CloneMediaInput { media: any[]; }
interface DisconnectInput { frageId: number; imageId: number; }

export const postFragenblock = (data: PostInput, config: AxiosRequestConfig = {}) => {
    return apiClient.post(`${strapiApiUrl}/fragenblocks`, {
        data
    }, config);
};

export const putFragenblock = (data: PutInput, config: AxiosRequestConfig = {}) => {
    return apiClient.put(`${strapiApiUrl}/fragenblocks/${data.fragenblockFields.id}`, {
        data
    }, config);
};

export const disconnectAndDeleteFragenblockRecursive = (data: DeleteInput, config: AxiosRequestConfig = {}) => {
    return apiClient.put(`${strapiApiUrl}/fragenblocks/disconnect/${data.id}`, {
        data: {
            parentFragenblockId: data.parentId
        }
    }, config);
};

export const cloneMediaForFrages = (data: CloneMediaInput, config: AxiosRequestConfig = {}) => {
    return apiClient.put(`${strapiApiUrl}/fragenblocks/cloneMedia/0`, {
        data
    }, config);
};

export const replaceFragenblock = (data: ReplaceInput, config: AxiosRequestConfig = {}) => {
    return apiClient.post(`${strapiApiUrl}/fragenblocks/replace/`, {
        data
    }, config);
};

export const disconnectImageFromFrage = (data: DisconnectInput, config: AxiosRequestConfig = {}) => {
    return apiClient.put(`${strapiApiUrl}/frages/disconnectImage`, {
        imageIds: [data.imageId],
        frage: data.frageId
    }, config);
}